import { BOARD_DISPLAY_NAME } from '../boards/boardConstants';

export const ALIAS_TYPE = 'ALIAS';
export const ALIAS_DISPLAY_NAME = BOARD_DISPLAY_NAME;
